import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Radium from "radium";
import { semanticColors } from "../../../Globals/styles";
import { Scrollbars } from "react-custom-scrollbars";
import Signature from "./Signature";
import { dateToString } from "../../../Util/dateTime";
import { downloadBlob } from "../../../Util/downloadBlob";
import { absenceCodes } from "../../../Globals/constants";
import {} from "./actions";

class StaticDailyReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hide: true,
      document: null,
    };
  }

  getEmployeeHours = (timeRegistrations) => {
    let totalHours = 0;
    timeRegistrations.forEach((t) => {
      if (t.checkIn) {
        totalHours += t.hours;
      } else {
        totalHours += t.hours + t.nightHours;
      }
    });
    return totalHours;
  };

  getEmployeeOverHours = (timeRegistrations) => {
    let totalOverHours = 0;
    timeRegistrations.forEach((t) => {
      if (t.checkIn) {
        totalOverHours += t.nightHours;
      }
    });
    return totalOverHours;
  };
  isCheckInMode = (timeRegistrations) => {
    let isCheckIn = false;
    timeRegistrations.forEach((t) => {
      if (t.checkIn) {
        isCheckIn = true;
      }
    });
    return isCheckIn;
  };
  componentDidUpdate = (prevProps) => {
    if (!prevProps.isEditSignature && this.props.isEditSignature) {
      this.refs.scrollBar.scrollToBottom();
    }
  };
  renderStringWithLines = (string) => {
    return string.split("\n").map((subString, index) => {
      return (
        <span key={index}>
          {index !== 0 ? <br /> : null}
          {subString}{" "}
        </span>
      );
    });
  };
  renderEmployee = (timeRegistrations) => {
    let e = 0;
    timeRegistrations.forEach((t) => {
      if (t.employeeFunction !== "0") e += 1;
    });
    return e !== 0;
  };
  addColon = (time) => {
    if (!time || time.indexOf(":") > -1) {
      return time;
    }
    time = time.replace(",", "");
    time = time.replace(".", "");
    time = time.replace(" ", "");
    return time.slice(0, 2) + ":" + time.slice(2);
  };
  render() {
    const {
      description,
      englishDescription,
      employees,
      dailyReportDate,
      signature,
      isEditSignature,
      activities,
      deliveryNotes,
      materiale,
      materiel,
      measurements,
      stamdata,
      remark,
      englishRemark,
      controlAreas,
      currentDailyReportId,
      pics,
    } = this.props;

    let employeeNodes = [];

    let picers = pics.map((item, index) => {
      return (
        <div
          key={index}
          style={{
            padding: 10,
            borderRadius: "2px",
          }}
        >
          <div
            style={{
              boxShadow:
                "rgba(0, 0, 0, 0.2) 0px 0px 1px 0px, rgba(0, 0, 0, 0.1) 0px 6px 20px 0px",
            }}
          >
            <div
              style={{
                display: "table",
              }}
            >
              <img
                style={{
                  height: "320px",
                  display: "table-caption",
                  captionSide: "bottom",
                }}
                src={item.original}
                alt={item.originalAlt}
                srcSet={item.srcSet}
                sizes={item.sizes}
              />
              <div
                style={{
                  minHeight: "40px",
                  backgroundColor: "white",
                  display: "table-caption",
                  captionSide: "bottom",
                  padding: "10",
                }}
              >
                {item.description}
              </div>
            </div>
          </div>
        </div>
      );
    });

    employees.forEach((employee) => {
      let isCheckInMode = this.isCheckInMode(employee.timeRegistrations);
      let totalHours = this.getEmployeeHours(employee.timeRegistrations);
      if (isCheckInMode) {
        totalHours = totalHours - employee.break;
      }
      let hasSecondRow =
        employee.absence != null || employee.shack || employee.mileage !== 0;
      if (this.renderEmployee(employee.timeRegistrations) || hasSecondRow) {
        employeeNodes.push(
          <div key={employee.id} style={styles.employee.container}>
            <div className="row" style={styles.employee.headingRow}>
              <div className="col-xs-5" style={styles.employee.left}>
                Navn
              </div>
              <div className="col-xs-2" style={styles.employee.middle}>
                Sum timer
              </div>
              <div
                className="col-xs-2"
                style={[styles.employee.middle, { paddingRight: 0 }]}
              >
                {isCheckInMode ? "Pause timer" : null}
              </div>
              <div className="col-xs-3" style={styles.employee.right}>
                {isCheckInMode ? "Heraf Overtid/Nat" : null}
              </div>
            </div>
            <div className="row" style={styles.employee.row}>
              <div className="col-xs-5" style={styles.employee.left}>
                {employee.name}
              </div>
              <div className="col-xs-2" style={styles.employee.middle}>
                {totalHours}
              </div>
              <div
                className="col-xs-2"
                style={[styles.employee.middle, { paddingRight: 0 }]}
              >
                {isCheckInMode ? employee.break : null}
              </div>
              <div className="col-xs-3" style={styles.employee.right}>
                {isCheckInMode
                  ? this.getEmployeeOverHours(employee.timeRegistrations) +
                    " t."
                  : null}
              </div>
            </div>
            {hasSecondRow ? (
              <div>
                <div className="row" style={styles.employee.headingRow}>
                  <div className="col-xs-5" style={styles.employee.left}>
                    Fravær
                  </div>
                  <div className="col-xs-2" style={styles.employee.middle}>
                    Skurpenge
                  </div>
                  <div className="col-xs-5" style={styles.employee.right}>
                    Kørepenge i km
                  </div>
                </div>
                <div
                  className="row"
                  style={[
                    styles.employee.row,
                    totalHours === 0 && styles.employee.noBorder,
                  ]}
                >
                  <div className="col-xs-5" style={styles.employee.left}>
                    {employee.absence
                      ? absenceCodes[employee.absence.absenceCode]
                      : null}
                  </div>
                  <div className="col-xs-2" style={styles.employee.middle}>
                    {employee.shack ? (
                      <i
                        className="fa fa-check-square-o"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i className="fa fa-square-o" aria-hidden="true"></i>
                    )}
                  </div>
                  <div className="col-xs-5" style={styles.employee.right}>
                    {employee.mileage}
                  </div>
                </div>
              </div>
            ) : null}
            {this.renderEmployee(employee.timeRegistrations) ? (
              <div>
                <div className="row" style={styles.employee.headingRow}>
                  <div className="col-xs-5" style={styles.employee.left}>
                    Funktion
                  </div>
                  <div className="col-xs-2" style={styles.employee.middle}>
                    {isCheckInMode ? "Start tid" : "Dag"}
                  </div>
                  <div className="col-xs-5" style={styles.employee.right}>
                    {isCheckInMode ? "Slut tid" : "Overtid/Nat"}
                  </div>
                </div>
                {employee.timeRegistrations.map((timeRegistration, i) => {
                  return (
                    <div
                      key={i}
                      className="row"
                      style={[
                        styles.employee.row,
                        i === employee.timeRegistrations.length - 1 &&
                          styles.employee.noBorder,
                        i !== employee.timeRegistrations.length - 1 &&
                          styles.employee.notLastTimeRegistration,
                      ]}
                    >
                      <div className="col-xs-5" style={styles.employee.left}>
                        {timeRegistration.employeeFunction}
                      </div>
                      <div className="col-xs-2" style={styles.employee.middle}>
                        {isCheckInMode
                          ? this.addColon(timeRegistration.checkIn)
                          : timeRegistration.hours}
                      </div>
                      <div className="col-xs-5" style={styles.employee.right}>
                        {isCheckInMode
                          ? this.addColon(timeRegistration.checkOut)
                          : timeRegistration.nightHours}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
        );
      }
    });

    //ACTIVITIES
    let activityNodes = [];

    activities.forEach((activity, i) => {
      if (activity.name) {
        activityNodes.push(
          <div key={i} className="row" style={styles.activity.row}>
            <div
              className="col-xs-3"
              style={[styles.activity.left, styles.noPadding]}
            >
              {activity.activity}
            </div>
            <div className="col-xs-6" style={styles.noPadding}>
              {activity.name}
            </div>
            <div
              className="col-xs-3"
              style={[styles.activity.right, styles.noPadding]}
            >
              {activity.hours}
            </div>
          </div>
        );
      }
    });

    //DELIVERY NOTES
    let deliveryNoteNodes = [];

    deliveryNotes.forEach((deliveryNote, i) => {
      if (deliveryNote.number) {
        deliveryNoteNodes.push(
          <div key={i} className="row" style={styles.deliveryNotes.row}>
            <div className="col-xs-3" style={styles.deliveryNotes.col}>
              {deliveryNote.number}
            </div>
            <div className="col-xs-4" style={styles.deliveryNotes.col}>
              {deliveryNote.supplier}
            </div>
            <div className="col-xs-5" style={styles.deliveryNotes.col}>
              {deliveryNote.specification}
            </div>
          </div>
        );
      }
    });

    //Materiel
    let materielNodes = [];

    materiel.forEach((m, i) => {
      if (m.name) {
        materielNodes.push(
          <div key={i}>
            <div className="row" style={styles.usage.row}>
              <div className="col-xs-8" style={styles.usage.left}>
                {m.name}
              </div>
              <div className="col-xs-2" style={styles.usage.middle}>
                {m.amount}
              </div>
              <div className="col-xs-2" style={styles.usage.right}>
                {m.unit}
              </div>
            </div>
            {m.subs && m.subs.length > 0
              ? m.subs.map((sub, index) => {
                  return (
                    <div key={index} style={styles.usage.row}>
                      <div className="col-xs-12">serienummer: {sub}</div>
                    </div>
                  );
                })
              : null}
          </div>
        );
      }
    });

    //Materiale
    let materialeNodes = [];

    materiale.forEach((m, i) => {
      if (m.name) {
        materialeNodes.push(
          <div key={i}>
            <div className="row" style={styles.usage.row}>
              <div className="col-xs-7" style={styles.usage.left}>
                {m.name}
              </div>
              <div className="col-xs-1" style={styles.usage.middle}>
                {m.dataSheet &&
                m.dataSheet !== "none" &&
                m.dataSheet !== "pending" ? (
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={async () => {
                      let notABlob = m.dataSheet;

                      let blob = undefined;
                      const myRequest = new Request(notABlob);
                      await fetch(myRequest)
                        .then((response) => response.blob())
                        .then((myBlob) => {
                          blob = myBlob;
                        });
                      downloadBlob(blob, m.name + ".sikkerhed.pdf");
                    }}
                    onTouchStart={() => this.props.openPdf(m.dataSheet)}
                    title="Datablad"
                  >
                    {/* Hent */}
                    <i
                      style={{ paddingLeft: 5 }}
                      className="fa fa-file-pdf-o"
                    ></i>
                  </a>
                ) : null}
              </div>
              <div className="col-xs-1" style={styles.usage.middle}>
                {m.technicalDataSheet &&
                m.technicalDataSheet !== "none" &&
                m.technicalDataSheet !== "pending" ? (
                  <a
                    onClick={async () => {
                      let notABlob = m.technicalDataSheet;

                      let blob = undefined;
                      const myRequest = new Request(notABlob);
                      await fetch(myRequest)
                        .then((response) => response.blob())
                        .then((myBlob) => {
                          blob = myBlob;
                        });
                      downloadBlob(blob, m.name + ".teknisk.pdf");
                    }}
                    onTouchStart={() =>
                      this.props.openPdf(m.technicalDataSheet)
                    }
                    title="Datablad"
                  >
                    {/* Hent */}
                    <i
                      style={{ paddingLeft: 5 }}
                      className="fa fa-file-pdf-o"
                    ></i>
                  </a>
                ) : null}
              </div>
              <div className="col-xs-1" style={styles.usage.middle}>
                {m.chemDataSheet &&
                m.chemDataSheet !== "none" &&
                m.chemDataSheet !== "pending" ? (
                  <a
                    onClick={async () => {
                      let notABlob = m.chemDataSheet;

                      let blob = undefined;
                      const myRequest = new Request(notABlob);
                      await fetch(myRequest)
                        .then((response) => response.blob())
                        .then((myBlob) => {
                          blob = myBlob;
                        });
                      downloadBlob(blob, m.name + ".kemisk.pdf");
                    }}
                    onTouchStart={() => this.props.openPdf(m.chemDataSheet)}
                    title="Datablad"
                  >
                    {/* Hent */}
                    <i
                      style={{ paddingLeft: 5 }}
                      className="fa fa-file-pdf-o"
                    ></i>
                  </a>
                ) : null}
              </div>
              <div className="col-xs-1" style={styles.usage.middle}>
                {m.amount}
              </div>
              <div className="col-xs-1" style={styles.usage.right}>
                {m.unit}
              </div>
            </div>
            {m.subs && m.subs.length > 0
              ? m.subs.map((sub, index) => {
                  return (
                    <div key={index} style={styles.usage.row}>
                      <div className="col-xs-12">batch: {sub}</div>
                    </div>
                  );
                })
              : null}
          </div>
        );
      }
    });

    let measurementNodes = [];

    measurements.forEach((m, i) => {
      if (m.type) {
        measurementNodes.push(
          <div key={i} className="row" style={styles.measurements.row}>
            <div style={styles.measurements.firstColumn}>{m.type}</div>
            <div style={styles.measurements.secondColumn}>{m.amount}</div>
            <div style={styles.measurements.thirdColumn}>{m.length}</div>
            <div style={styles.measurements.forthColumn}>{m.depth}</div>
            <div style={styles.measurements.fifthColumn}>{m.area}</div>
          </div>
        );
      }
    });

    let controlAreaNodes = [];

    controlAreas.forEach((m, i) => {
      if (m.type) {
        controlAreaNodes.push(
          <div key={i} className="row" style={styles.measurements.row}>
            <div style={styles.controlAreas.firstColumn}>{m.type}</div>
            <div style={styles.controlAreas.secondColumn}>{m.temp}</div>
            <div style={styles.controlAreas.thirdColumn}>{m.crack}</div>
            <div style={styles.controlAreas.forthColumn}>{m.control}</div>
            <div style={styles.controlAreas.fifthColumn}>{m.rf}</div>
            <div style={styles.controlAreas.sixthColumn}>{m.mpa}</div>
            <div style={styles.controlAreas.seventhColumn}>{m.area}</div>
          </div>
        );
      }
    });

    return (
      <div style={styles.container}>
        <div style={styles.sideLinesContainer}>
          <div
            className="col-xs-offset-2 col-xs-8"
            style={styles.sideLines}
          ></div>
        </div>
        <div className="col-xs-offset-2 col-xs-8" style={styles.innerContainer}>
          <Scrollbars ref="scrollBar" style={{ height: "100%", width: "100%" }}>
            <div style={styles.contentContainer}>
              {
                /**************Empty STATE*****************/
                description ||
                employeeNodes.length ||
                activityNodes.length ||
                deliveryNoteNodes.length ||
                materielNodes.length ||
                materialeNodes.length ||
                measurementNodes.length ||
                remark ||
                signature ? (
                  /**************HEADING*****************/
                  <div>
                    <img
                      alt="billede"
                      style={styles.logo}
                      src="/images/CE-logo-NYT-75.jpg"
                    />
                    <div style={styles.entityContainer}>
                      <div
                        className="row"
                        style={[styles.doubleLine, styles.firstRow]}
                      >
                        <h3 style={styles.heading.left}>Dagrapport</h3>
                        <div style={[styles.heading.left, styles.date]}>
                          {dateToString(dailyReportDate)}
                        </div>
                      </div>
                    </div>
                    {/**************STAMDATA*****************/}
                    <div style={styles.entityContainer}>
                      <div className="row" style={styles.doubleLine}>
                        <div className="col-xs-5" style={styles.stamdata.col}>
                          <h3>Sag</h3>
                        </div>
                        <div className="col-xs-4" style={styles.stamdata.col}>
                          <h3>Bygherre</h3>
                        </div>
                        <div className="col-xs-3" style={styles.stamdata.col}>
                          <h3>ID / Arbejdssted</h3>
                        </div>
                      </div>
                      <div className="row" style={styles.stamdata.row}>
                        <div className="col-xs-5" style={styles.stamdata.col}>
                          {stamdata.project.number} <br />
                          {stamdata.project.name}
                        </div>
                        <div className="col-xs-4" style={styles.stamdata.col}>
                          {stamdata.client.name} <br />
                          {stamdata.client.contact}
                        </div>
                        <div className="col-xs-3" style={styles.stamdata.col}>
                          {stamdata.workplaceName}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={styles.entityContainer}>
                    <img
                      style={styles.img}
                      alt="Dagrapporten er tom"
                      src="/images/emptyStates/Emptystate_dagrapport.png"
                    />
                  </div>
                )
              }

              {
                /**************DESCRIPTION*****************/
                description ? (
                  <div style={styles.entityContainer}>
                    <h3 style={styles.doubleLine}>
                      Beskrivelse{" "}
                      {englishDescription ? (
                        <span style={styles.translateSmallText}>
                          {" "}
                          / Description
                        </span>
                      ) : null}
                    </h3>
                    <div style={styles.contentPadding}>
                      {englishDescription ? (
                        <span style={styles.translateSmallText}>(Dansk) </span>
                      ) : null}
                      {this.renderStringWithLines(description)}
                    </div>
                    {englishDescription ? (
                      <div
                        style={[styles.contentPadding, { marginTop: "5px" }]}
                      >
                        <span style={styles.translateSmallText}>
                          (English){" "}
                        </span>
                        {this.renderStringWithLines(englishDescription)}
                      </div>
                    ) : null}
                  </div>
                ) : null
              }

              {
                /**************EMPLOYEES*****************/
                employeeNodes.length ? (
                  <div style={styles.entityContainer}>
                    <h3 style={styles.doubleLine}>Mandskab</h3>
                    {employeeNodes}
                  </div>
                ) : null
              }

              {
                /**************ACTIVITIES*****************/
                activityNodes.length ? (
                  <div style={styles.entityContainer}>
                    <div className="row" style={styles.doubleLine}>
                      <h3 style={styles.activity.left}>Aktiviteter</h3>
                      <div style={styles.activity.right}>Timer</div>
                    </div>

                    {activityNodes}
                  </div>
                ) : null
              }

              {
                /**************DELIVERY NOTES*****************/
                deliveryNoteNodes.length ? (
                  <div style={styles.entityContainer}>
                    <h3 style={styles.deliveryNotes.heading}>Følgesedler</h3>
                    <div className="row" style={styles.doubleLine}>
                      <div
                        className="col-xs-3"
                        style={styles.deliveryNotes.col}
                      >
                        Nummer
                      </div>
                      <div
                        className="col-xs-4"
                        style={styles.deliveryNotes.col}
                      >
                        Leverandør
                      </div>
                      <div
                        className="col-xs-5"
                        style={styles.deliveryNotes.col}
                      >
                        Specifikation
                      </div>
                    </div>

                    {deliveryNoteNodes}
                  </div>
                ) : null
              }

              {
                /**************MATERIEL*****************/
                materielNodes.length ? (
                  <div style={styles.entityContainer}>
                    <h3 style={styles.usage.heading}>Materiel/Maskiner</h3>
                    <div className="row" style={styles.doubleLine}>
                      <div className="col-xs-8" style={styles.usage.left}>
                        Art
                      </div>
                      <div className="col-xs-2" style={styles.usage.middle}>
                        Antal
                      </div>
                      <div className="col-xs-2" style={styles.usage.right}>
                        Enhed
                      </div>
                    </div>
                    {materielNodes}
                  </div>
                ) : null
              }

              {
                /**************MATERIALE*****************/
                materialeNodes.length ? (
                  <div style={styles.entityContainer}>
                    <h3 style={styles.usage.heading}>Materiale</h3>
                    <div className="row" style={styles.doubleLine}>
                      <div className="col-xs-7" style={styles.usage.left}>
                        Art
                      </div>
                      <div className="col-xs-1" style={styles.usage.middle}>
                        SDS
                      </div>
                      <div className="col-xs-1" style={styles.usage.middle}>
                        TDS
                      </div>
                      <div className="col-xs-1" style={styles.usage.middle}>
                        KEMI
                      </div>
                      <div className="col-xs-1" style={styles.usage.middle}>
                        Antal
                      </div>
                      <div className="col-xs-1" style={styles.usage.right}>
                        Enhed
                      </div>
                    </div>
                    {materialeNodes}
                    <div
                      style={{
                        fontSize: 10,
                        float: "right",
                        textAlign: "right",
                        paddingTop: 10,
                      }}
                    >
                      <div>SDS = Sikkerheds datablad</div>
                      <div>TDS = Teknisk datablad</div>
                      <div>KEMI = Kemisk Risikovurdering</div>
                    </div>
                  </div>
                ) : null
              }

              {
                /**************MEASUREMENTS*****************/
                measurementNodes.length ? (
                  <div style={styles.entityContainer}>
                    <h3 style={styles.measurements.heading}>Opmåling</h3>
                    <div
                      className="row"
                      style={[
                        styles.doubleLine,
                        styles.measurements.headingRow,
                      ]}
                    >
                      <div
                        style={[
                          styles.measurements.firstColumn,
                          styles.measurements.headingPadding,
                        ]}
                      >
                        Art
                      </div>
                      <div style={styles.measurements.secondColumn}>
                        Antal <br /> stk/snit
                      </div>
                      <div style={styles.measurements.thirdColumn}>
                        Længde (cm) <br /> Diameter (mm)
                      </div>
                      <div style={styles.measurements.forthColumn}>
                        Dybde <br /> (cm)
                      </div>
                      <div
                        style={[
                          styles.measurements.fifthColumn,
                          styles.measurements.headingPadding,
                        ]}
                      >
                        Område
                      </div>
                    </div>
                    {measurementNodes}
                  </div>
                ) : null
              }

              {controlAreaNodes.length ? (
                <div style={styles.entityContainer}>
                  <h3 style={styles.measurements.heading}>Kontrol</h3>
                  <div
                    className="row"
                    style={[styles.doubleLine, styles.measurements.headingRow]}
                  >
                    <div
                      style={[
                        styles.controlAreas.firstColumn,
                        styles.measurements.headingPadding,
                      ]}
                    >
                      Type
                    </div>
                    <div style={styles.controlAreas.secondColumn}>Temp C°</div>
                    <div style={styles.controlAreas.thirdColumn}>
                      Revnevidde mm
                    </div>
                    <div style={styles.controlAreas.forthColumn}>
                      Mat. kontrol min.
                    </div>
                    <div style={styles.controlAreas.fifthColumn}>Rf %</div>
                    <div style={styles.controlAreas.sixthColumn}>
                      Trækprøve mpa
                    </div>
                    <div
                      style={[
                        styles.controlAreas.seventhColumn,
                        styles.measurements.headingPadding,
                      ]}
                    >
                      Område
                    </div>
                  </div>
                  {controlAreaNodes}
                </div>
              ) : null}

              {
                /**************REMARK --> uses same style as description*****************/
                remark ? (
                  <div style={styles.entityContainer}>
                    <h3 style={styles.doubleLine}>
                      Bemærkning{" "}
                      {englishRemark ? (
                        <span style={styles.translateSmallText}> / Remark</span>
                      ) : null}
                    </h3>
                    <div style={styles.contentPadding}>
                      {englishRemark ? (
                        <span style={styles.translateSmallText}>(Dansk) </span>
                      ) : null}
                      {this.renderStringWithLines(remark)}
                    </div>
                    {englishRemark ? (
                      <div
                        style={[styles.contentPadding, { marginTop: "5px" }]}
                      >
                        <span style={styles.translateSmallText}>
                          (English){" "}
                        </span>
                        {this.renderStringWithLines(englishRemark)}
                      </div>
                    ) : null}
                  </div>
                ) : null
              }

              {
                /**************SIGNATURE*****************/
                signature ? (
                  <div style={styles.signature.container}>
                    <h3>Underskrift</h3>
                    <div style={styles.signature.dateContainer}>
                      {dateToString(signature.dateOfSignature)}
                    </div>
                    <div style={styles.signature.imageContainer}>
                      <img
                        alt="billede"
                        style={styles.signature.image}
                        src={signature.signature}
                      />
                      <div style={styles.signature.name}>{signature.name}</div>
                    </div>
                  </div>
                ) : null
              }

              {isEditSignature ? (
                <Signature currentDailyReportId={currentDailyReportId} />
              ) : null}
              {picers.length > 0 ? (
                <div style={{ paddingTop: 50 }}>
                  <h3>Billeder</h3>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly" /* align horizontal */,
                      alignItems: "center",
                      flexFlow: "row wrap",
                      padding: "20px",
                    }}
                  >
                    {picers}
                  </div>
                </div>
              ) : null}
            </div>
          </Scrollbars>
        </div>
      </div>
    );
  }
}

const isMas = process.env.REACT_APP_title.includes("Mas");
var styles = {
  container: {
    height: "100%",
    position: "relative",
  },
  img: {
    margin: "0 auto",
    display: "block",
  },
  innerContainer: {
    height: "100%",
    padding: "0",
    backgroundColor: "white",
  },
  contentContainer: {
    padding: "0 50px",
    marginTop: 20,
  },
  sideLinesContainer: {
    height: "100%",
    width: "100%",
    position: "absolute",
    top: "0",
    left: "0",
    padding: "30px 0",
  },
  sideLines: {
    height: "100%",
    borderLeft: "2px solid " + semanticColors.mainBackground,
    borderRight: "2px solid " + semanticColors.mainBackground,
  },
  doubleLine: {
    borderBottom: "4px double " + semanticColors.mainBackground,
    lineHeight: "1.2em",
    margin: "0",
    padding: "4px 0",
  },
  entityContainer: {
    marginBottom: "20px",
  },
  contentPadding: {
    padding: "0 4px",
  },
  heading: {
    left: {
      float: "left",
    },
    right: {
      float: "right",
      fontSize: "12px",
    },
  },
  stamdata: {
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      lineHeight: "25px",
    },
    col: {
      paddingLeft: "0",
    },
  },
  employee: {
    container: {
      border: "1px solid " + semanticColors.mainBackground,
      borderRadius: "2px",
      marginTop: "6px",
      padding: "6px 4px 0 4px",
    },
    headingRow: {
      height: "15px",
      lineHeight: "15px",
      textAlign: "center",
      fontSize: "12px",
      margin: "0",
    },
    row: {
      height: "23px",
      lineHeight: "23px",
      borderBottom: "1px solid " + semanticColors.mainBackground,
      padding: "0",
      textAlign: "center",
      margin: "0 6px 6px 6px",
    },
    left: {
      textAlign: "left",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
    middle: {},
    right: {
      textAlign: "right",
    },
    notLastTimeRegistration: {
      margin: "0 6px 0px 6px",
    },
    noBorder: {
      borderBottom: "none",
      margin: "0 6px 6px 6px",
    },
  },
  signature: {
    container: {
      height: "120px",
      width: "100%",
      position: "relative",
    },
    dateContainer: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      float: "left",
      width: "30%",
      position: "absolute",
      top: "95px",
    },
    imageContainer: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      float: "right",
      width: "66%",
      position: "relative",
    },
    image: {
      width: "380px",
      height: "100px",
    },
    name: {
      position: "absolute",
    },
  },
  activity: {
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      height: "100%",
      lineHeight: "25px",
      overflow: "auto",
    },
    left: {
      textAlign: "left",
      float: "left",
    },
    right: {
      textAlign: "right",
      float: "right",
    },
  },
  noPadding: {
    padding: "0px",
  },
  deliveryNotes: {
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      lineHeight: "25px",
    },
    col: {
      paddingLeft: "0",
    },
    heading: {
      marginBottom: "10px",
    },
  },
  usage: {
    heading: {
      marginBottom: "10px",
    },
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      height: "25px",
      lineHeight: "25px",
    },
    left: {
      textAlign: "left",
      padding: "0",
    },
    right: {
      textAlign: "right",
      padding: "0",
    },
    middle: {
      textAlign: "center",
      padding: "0",
    },
  },
  measurements: {
    heading: {
      marginBottom: "10px",
    },
    headingRow: {
      lineHeight: "1.3em",
    },
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      lineHeight: "25px",
    },
    headingPadding: {
      paddingTop: "18px",
    },
    firstColumn: {
      width: "21%",
      paddingRight: "12px",
      paddingLeft: "0",
      float: "left",
    },
    secondColumn: {
      width: "12%",
      paddingRight: "12px",
      paddingLeft: "0",
      float: "left",
      textAlign: "right",
    },
    thirdColumn: {
      width: "20%",
      paddingRight: "12px",
      paddingLeft: "0",
      float: "left",
      textAlign: "right",
    },
    forthColumn: {
      width: "12%",
      paddingRight: "12px",
      paddingLeft: "0",
      float: "left",
      textAlign: "right",
    },
    fifthColumn: {
      width: "35%",
      paddingRight: "12px",
      paddingLeft: "0",
      float: "left",
    },
  },
  controlAreas: {
    heading: {
      marginBottom: "10px",
    },
    headingRow: {
      lineHeight: "1.3em",
    },
    row: {
      borderBottom: "1px solid " + semanticColors.mainBackground,
      margin: "0",
      paddingLeft: "4px",
      lineHeight: "25px",
    },
    headingPadding: {
      paddingTop: "18px",
    },
    firstColumn: {
      width: "13%",
      paddingRight: "6px",
      paddingLeft: "0",
      float: "left",
    },
    secondColumn: {
      width: "13%",
      paddingRight: "6px",
      paddingLeft: "0",
      float: "left",
    },
    thirdColumn: {
      width: "12%",
      paddingRight: "6px",
      paddingLeft: "0",
      float: "left",
    },
    forthColumn: {
      width: "13%",
      paddingRight: "6px",
      paddingLeft: "0",
      float: "left",
    },
    fifthColumn: {
      width: "9%",
      paddingRight: "6px",
      paddingLeft: "0",
      float: "left",
    },
    sixthColumn: {
      width: "13%",
      paddingRight: "6px",
      paddingLeft: "0",
      float: "left",
    },
    seventhColumn: {
      width: "26%",
      paddingRight: "0px",
      paddingLeft: "0",
      float: "left",
    },
  },
  translateSmallText: {
    fontSize: "12px",
    fontWeight: "600",
  },
  firstRow: {
    padding: "30px 0px 4px 0px",
  },
  date: {
    marginLeft: "10px",
  },
  logo: {
    width: isMas ? "200px" : "90px",
    height: "45px",
    float: "right",
  },
};

const selectProps = (state) => {
  return {
    isEditSignature: state.dailyReportReducer.isEditSignature,
    description: state.dailyReportDescriptionReducer.description,
    englishDescription: state.dailyReportDescriptionReducer.englishDescription,
    employees: state.dailyReportEmployeesReducer.employees,
    activities: state.dailyReportActivitiesReducer.activities,
    signature: state.dailyReportSignatureReducer.signature,
    deliveryNotes: state.dailyReportDeliveryNotesReducer.deliveryNotes,
    materiel: state.dailyReportUsageReducer.materiel,
    materiale: state.dailyReportUsageReducer.materiale,
    measurements: state.dailyReportMeasurementsReducer.measurements,
    controlAreas: state.dailyReportControlAreaReducer.controlAreas,
    stamdata: state.dailyReportReducer.stamdata,
    dailyReportDate: state.dailyReportReducer.date,
    remark: state.dailyReportRemarkReducer.remark,
    englishRemark: state.dailyReportRemarkReducer.englishRemark,
    currentDailyReportId: state.dailyReportReducer.currentDailyReportId,
    pics: state.dailyReportReducer.pics,
  };
};

StaticDailyReport.propTypes = {
  dispatch: PropTypes.func.isRequired,
  workplaceId: PropTypes.string.isRequired,
  dailyReportDate: PropTypes.instanceOf(Date),
  description: PropTypes.string.isRequired,
  englishDescription: PropTypes.string,
  remark: PropTypes.string.isRequired,
  englishRemark: PropTypes.string,
  stamdata: PropTypes.shape({
    client: PropTypes.shape({
      contact: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    workplaceName: PropTypes.string.isRequired,
    project: PropTypes.shape({
      name: PropTypes.string,
      number: PropTypes.string,
    }).isRequired,
  }).isRequired,
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      absence: PropTypes.shape({
        date: PropTypes.object.isRequired,
        hours: PropTypes.number.isRequired,
        absenceCode: PropTypes.string,
      }),
      mileage: PropTypes.number.isRequired,
      shack: PropTypes.bool.isRequired,
      timeRegistrations: PropTypes.arrayOf(
        PropTypes.shape({
          hours: PropTypes.number.isRequired,
          nightHours: PropTypes.number.isRequired,
          employeeFunction: PropTypes.string,
        })
      ).isRequired,
    })
  ),
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      hours: PropTypes.number,
    })
  ),
  deliveryNotes: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string.isRequired,
      supplier: PropTypes.string.isRequired,
      specification: PropTypes.string,
    })
  ),
  materiel: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      unit: PropTypes.string,
      amount: PropTypes.number,
    })
  ),
  materiale: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string.isRequired,
      unit: PropTypes.string,
      amount: PropTypes.number,
    })
  ),
  measurements: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      length: PropTypes.number.isRequired,
      depth: PropTypes.number.isRequired,
      area: PropTypes.string,
      amount: PropTypes.number.isRequired,
    })
  ),
  signature: PropTypes.shape({
    dateOfSignature: PropTypes.object.isRequired,
    signature: PropTypes.string.isRequired,
    name: PropTypes.string,
  }),
  isEditSignature: PropTypes.bool.isRequired,
  currentDailyReportId: PropTypes.string,
};

export default connect(selectProps)(Radium(StaticDailyReport));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/staticDailyReport.jsx